'use client';

import * as React from 'react';

import type { SetupExperienceStage } from '@/components/setup/experience/lib/setupSteps';

interface SetupShellContextValue {
  macroIndex: number;
  progressPercent: number;
  stage: SetupExperienceStage;
}

const SetupShellContext = React.createContext<SetupShellContextValue | null>(null);

interface SetupShellProviderProps {
  macroIndex: number;
  /** Total steps in the current strip (varies with store kind: 4 physical, 3 digital). */
  totalSteps: number;
  stage: SetupExperienceStage;
  children: React.ReactNode;
}

export function SetupShellProvider({
  macroIndex,
  totalSteps,
  stage,
  children,
}: SetupShellProviderProps) {
  const progressPercent = totalSteps > 0 ? Math.round(((macroIndex + 1) / totalSteps) * 100) : 0;

  const value = React.useMemo(
    () => ({ macroIndex, progressPercent, stage }),
    [macroIndex, progressPercent, stage],
  );

  return <SetupShellContext.Provider value={value}>{children}</SetupShellContext.Provider>;
}

export function useSetupShellContext() {
  return React.useContext(SetupShellContext);
}
